import { FC, ReactNode, useState } from 'react';
import './IosModal.scss';

interface IIosModal {
    title: string;
    cancel: Function;
    aprove?: Function;
    children: ReactNode;
    cancelBtnTitle: string;
    aproveBtnTitle?: string;
    backButtonTitle?: string;
    backButton?: Function;
}

const IosModal: FC<IIosModal> = ({ backButton, backButtonTitle, cancel, title = '', aprove, children, cancelBtnTitle = '', aproveBtnTitle = '' }) => {
    const [closed, setClosed] = useState(false);

    function close() {
        setClosed(true);
        setTimeout(() => {
            cancel();
        }, 200);
    }
    return (
        <div className="ios-modal">
            <div
                className="ios-modal__dialog"
                id={closed ? 'closed' : ''}>
                <div className="dialog__header">
                    {backButton && backButtonTitle ? (
                        <button
                            className="cancel-btn"
                            style={{ justifyContent: 'start' }}
                            onClick={() => backButton()}>
                            {backButtonTitle}
                        </button>
                    ) : (
                        <button
                            className="cancel-btn"
                            style={{ justifyContent: 'start' }}
                            onClick={close}>
                            {cancelBtnTitle}
                        </button>
                    )}
                    <h1>{title}</h1>
                    <button
                        style={{ justifyContent: 'end' }}
                        onClick={() => aprove && aproveBtnTitle && aprove()}>
                        {aproveBtnTitle}
                    </button>
                </div>
                <div className="dialog__content">{children}</div>
            </div>
        </div>
    );
};

export default IosModal;
